import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

// Conectar el Telegram del dueño para recibir el aviso de las 9 de la mañana.
//
// Por qué el enlace va al revés de lo que uno esperaría: Telegram no deja que
// un bot le escriba a alguien que no le habló antes. No basta con escribir aquí
// un número. Hay que abrir el bot, mandarle un código, y el servidor lo busca
// entre los mensajes que le llegaron. Eso además prueba que ese Telegram es
// suyo: nadie puede poner a otra persona a recibir su cartera.

function AvisoDiario() {
  const [estado, setEstado] = useState(null);
  const [codigo, setCodigo] = useState('');
  const [aviso, setAviso] = useState('');
  const [ocupado, setOcupado] = useState(false);

  const cargar = useCallback(async () => {
    try {
      const r = await axios.get('/api/telegram/estado');
      setEstado(r.data);
    } catch (e) {
      setEstado({ enlazado: false, hay_bot: false, error: true });
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const pedirCodigo = async () => {
    setOcupado(true); setAviso('');
    try {
      const r = await axios.post('/api/telegram/codigo');
      setCodigo(r.data.codigo);
    } catch (e) {
      setAviso(e.response?.data?.error || 'No se pudo pedir el código');
    }
    setOcupado(false);
  };

  const comprobar = async () => {
    setOcupado(true); setAviso('');
    try {
      const r = await axios.post('/api/telegram/vincular');
      if (r.data.enlazado) { setCodigo(''); await cargar(); }
      else setAviso(r.data.mensaje || 'Todavía no llega su mensaje');
    } catch (e) {
      setAviso(e.response?.data?.error || 'No se pudo comprobar');
    }
    setOcupado(false);
  };

  const probar = async () => {
    setOcupado(true); setAviso('');
    try {
      const r = await axios.post('/api/telegram/probar');
      setAviso(r.data.enviado
        ? '✅ Se lo acabo de mandar. Revise Telegram.'
        : (r.data.mensaje || 'No había nada que mandar'));
    } catch (e) {
      setAviso(e.response?.data?.error || 'No se pudo enviar');
    }
    setOcupado(false);
  };

  const cambiarAviso = async (encendido) => {
    try {
      await axios.put('/api/telegram/aviso', { aviso_diario: encendido });
      await cargar();
    } catch (e) { setAviso('No se pudo guardar'); }
  };

  const desenlazar = async () => {
    if (!window.confirm('¿Dejar de recibir el aviso de la mañana?')) return;
    try { await axios.delete('/api/telegram/vincular'); await cargar(); }
    catch (e) { setAviso('No se pudo desconectar'); }
  };

  if (!estado) return null;

  const caja = {
    background: 'white', border: '1px solid #e5e7eb', borderRadius: '10px',
    padding: '22px', marginBottom: '20px',
  };
  const boton = {
    padding: '10px 18px', borderRadius: '7px', border: 'none',
    background: '#667eea', color: 'white', fontWeight: 600,
    cursor: ocupado ? 'wait' : 'pointer', fontSize: '14px',
  };

  return (
    <div style={caja}>
      <h3 style={{ color: '#1f2937', marginBottom: '6px' }}>
        🔔 El aviso de las 9 de la mañana
      </h3>
      <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '18px', lineHeight: 1.5 }}>
        Cada mañana le llega a su Telegram la lista de a quién le vence el mes
        hoy y cuánto cobrarle. Usted abre el programa y usa el botón 💬 de cada
        cliente: el WhatsApp sale de su propio teléfono, con su nombre.
        <br />
        <strong>A los clientes no se les escribe nada automático.</strong>
      </p>

      {!estado.hay_bot && (
        <div style={{ background: '#fffbeb', border: '1px solid #fde68a',
                      color: '#92400e', padding: '12px', borderRadius: '7px', fontSize: '14px' }}>
          El bot de Telegram todavía no está configurado en el servidor.
          Avísele a quien le vendió el programa.
        </div>
      )}

      {estado.hay_bot && estado.enlazado && (
        <div>
          <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0',
                        color: '#15803d', padding: '12px', borderRadius: '7px',
                        fontSize: '14px', marginBottom: '16px' }}>
            ✅ Su Telegram está conectado.
          </div>

          <label style={{ display: 'flex', alignItems: 'center', gap: '10px',
                          marginBottom: '16px', cursor: 'pointer', color: '#374151' }}>
            <input type="checkbox" checked={estado.aviso_diario}
                   onChange={(e) => cambiarAviso(e.target.checked)} />
            Mandarme el aviso todas las mañanas
          </label>

          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button style={boton} onClick={probar} disabled={ocupado}>
              Mandármelo ahora para verlo
            </button>
            <button
              style={{ ...boton, background: '#f3f4f6', color: '#4b5563' }}
              onClick={desenlazar} disabled={ocupado}>
              Desconectar
            </button>
          </div>
        </div>
      )}

      {estado.hay_bot && !estado.enlazado && !codigo && (
        <button style={boton} onClick={pedirCodigo} disabled={ocupado}>
          Conectar mi Telegram
        </button>
      )}

      {estado.hay_bot && !estado.enlazado && codigo && (
        <div>
          <ol style={{ color: '#374151', fontSize: '14px', lineHeight: 1.9,
                       marginLeft: '18px', marginBottom: '16px' }}>
            <li>Abra Telegram en su teléfono.</li>
            <li>Busque el bot de FlexFlow y toque <strong>Iniciar</strong>.</li>
            <li>Mándele este código tal cual:</li>
          </ol>
          <div style={{ background: '#f3f4f6', border: '2px dashed #d1d5db',
                        borderRadius: '8px', padding: '16px', textAlign: 'center',
                        fontSize: '24px', fontWeight: 700, letterSpacing: '2px',
                        color: '#1f2937', marginBottom: '16px' }}>
            {codigo}
          </div>
          <button style={boton} onClick={comprobar} disabled={ocupado}>
            Ya lo mandé, compruebe
          </button>
        </div>
      )}

      {aviso && (
        <p style={{ marginTop: '14px', fontSize: '14px', color: '#4b5563' }}>{aviso}</p>
      )}
    </div>
  );
}

export default AvisoDiario;
